import _ from 'lodash';
import {fromJS, List, Map} from 'immutable';

import * as actions from './actions';
import {UPDATE_QUESTION, NEW_QUESTION} from '../questions/actions';
import {
    isPaperScanTemplate,
    PAPER_SCAN_TEMPLATE_SETTINGS,
} from './paper_scan_layout';


export default function reducer(state, action) {
    if (!state.get('selectedQuestions'))
        state = state.set('selectedQuestions', new List());
    if (!state.get('questions'))
        state = state.set('questions', new Map());

    if (state.get('elementId') + ':questions' === action.elementId) {
        switch (action.type) {
        case UPDATE_QUESTION:
            const question = state.get('questions').find(question => question.get('question_id') === action.payload.id);
            if (question) {
                state = state.mergeIn(
                    ['questions', question.get('id')],
                    {
                        ..._.pickBy(action.payload, (__, key) => !_.includes(['id', 'page'], key)),
                        answer_content: action.payload.answer,
                    },
                );
            }
            if (state.get('questions').get(-action.payload.id)) {
                state = state.mergeIn(
                    ['questions', -action.payload.id],
                    {
                        ..._.pickBy(action.payload, (__, key) => !_.includes(['id', 'page'], key)),
                        question_id: action.payload.id,
                        answer_content: action.payload.answer,
                    },
                );
            }
            break;

        case NEW_QUESTION:
            state = state.setIn(
                ['questions', -action.payload.id],
                fromJS({
                    ..._.pickBy(action.payload, (__, key) => !_.includes(['page'], key)),
                    id: -action.payload.id,
                    question_id: action.payload.id,
                    answer_content: action.payload.answer,
                    index: state.get('questions').count(),
                }),
            );
            state = state.updateIn(['selectedQuestions'], list => list.push(-action.payload.id));
            break;
        }
    }

    if (state.get('elementId') === action.elementId) {
        switch (action.type) {
        case actions.SET_QUESTIONS:
            state = state.set('questions', fromJS(_.mapKeys(
                _.filter(action.payload, item => item.question_id),
                question => question.id,
            )).mapKeys(Number.parseInt));
            state = state.set(
                'selectedQuestions',
                state.get('questions').sortBy(item => item.get('index')).toList().map(item => item.get('id')),
            );
            break;

        case actions.ADD_QUESTION:
            if (state.get('selectedQuestions').findIndex(id => state.getIn(['questions', id, 'question_id']) === action.payload.id) === -1) {
                state = state.mergeIn(
                    ['questions', -action.payload.id],
                    {
                        ..._.pickBy(action.payload, (__, key) => !_.includes(['page'], key)),
                        id: -action.payload.id,
                        question_id: action.payload.id,
                        answer_content: action.payload.answer,
                        index: state.get('questions').count(),
                        coefficient: 1,
                    },
                );
                state = state.updateIn(['selectedQuestions'], list => list.push(-action.payload.id));
            }
            break;

        case actions.REMOVE_QUESTION: {
            let index = state.get('selectedQuestions').findIndex(id => id === action.payload);
            if (index !== -1) {
                state = state.updateIn(
                    ['selectedQuestions'],
                    list => list.remove(index),
                );
                state = state.removeIn(
                    ['questions', action.payload],
                );
                index = 0;
                state = state.update('questions', questions => questions.sortBy(item => item.get('index')).map(
                    item => {
                        if (item.get('question_id'))
                            return item.set('index', index++);
                        else
                            return item;
                    },
                )).toMap();
            }
            break;
        }

        case actions.SET_FAKE:
            state = state.updateIn(['questions', action.payload.id, 'fake'], () => action.payload.fake);
            break;

        case actions.SET_COEFFICIENT:
            if (Number.isInteger(action.payload.coefficient))
                state = state.updateIn(['questions', action.payload.id, 'coefficient'], () => action.payload.coefficient);
            break;

        case actions.REORDER:
            const order = _.mapKeys(
                _.mapValues(action.payload, (id, index) => ({index: Number(index), id})),
                item => item.id,
            );
            state = state.updateIn(
                ['questions'],
                items => items.map(item => item.get('question_id') ? item.set('index', order[item.get('id')].index) : item),
            );
            state = state.set(
                'selectedQuestions',
                state.get('questions').sortBy(item => item.get('index')).toList().map(item => item.get('id')),
            );
            break;

        case actions.UPDATE_QUESTION_LAYOUT:
        case actions.UPDATE_ANSWER_LAYOUT:
            let changed = false;
            action.payload.forEach(item => {
                if (
                    item.get('index') !== undefined && item.get('index') !== null &&
                    item.get('index') !== state.getIn(['questions', item.get('id'), 'index'])
                ) {
                    state = state.setIn(['questions', item.get('id'), 'index'], item.get('index'));
                    changed = true;
                }
            });
            if (changed)
                state = state.set(
                    'selectedQuestions',
                    state.get('questions').sortBy(item => item.get('index')).toList().map(item => item.get('id')),
                );
            break;
        }
    }
    return state;
}

export function layoutReducer(state=fromJS({elementId: window.uuidv4(), questions: new Map(), answers: new Map()}), action) {
    if (state.get('elementId').split(':')[0] + ':questions' === action.elementId) {
        switch (action.type) {
        case UPDATE_QUESTION:
            const question = state.get('questions').find(question => question.get('question_id') === action.payload.id);
            if (question) {
                state = state.setIn(
                    ['questions', question.get('id'), 'content'],
                    action.payload.content || '',
                );
                state = state.setIn(
                    ['answers', question.get('id'), 'content'],
                    action.payload.answer || '',
                );
                state = state.setIn(
                    ['answers', question.get('id'), 'scores'],
                    null,
                );
            }
            if (state.get('questions').get(-action.payload.id)) {
                state = state.setIn(
                    ['questions', -action.payload.id, 'content'],
                    action.payload.content || '',
                );
                state = state.setIn(
                    ['answers', -action.payload.id, 'content'],
                    action.payload.answer || '',
                );
                state = state.setIn(
                    ['answers', -action.payload.id, 'scores'],
                    null,
                );
            }
            break;

        case NEW_QUESTION:
            state = state.mergeIn(
                ['questions', -action.payload.id],
                {
                    ..._.pickBy(action.payload, (__, key) => key !== 'id'),
                    id: -action.payload.id,
                    question_id: action.payload.id,
                    page: null,
                    top: null,
                    right: null,
                    width: null,
                    height: null,
                    content: action.payload.content || '',
                    index: state.get('questions').count(),
                },
            );
            state = state.mergeIn(
                ['answers', -action.payload.id],
                {
                    ..._.pickBy(action.payload, (__, key) => key !== 'id'),
                    id: -action.payload.id,
                    question_id: action.payload.id,
                    page: null,
                    top: null,
                    right: null,
                    width: null,
                    height: null,
                    content: action.payload.answer || '',
                    index: state.get('answers').count(),
                },
            );
            break;
        }
    }

    if (state.get('elementId') === action.elementId) {
        switch (action.type) {
        case actions.SET_LAYOUT:
            state = state.set('questions', fromJS(_.mapValues(
                _.mapKeys(
                    action.payload,
                    question => question.id,
                ),
                question => ({
                    id: question.id,
                    page: question.page,
                    top: question.top,
                    right: question.right,
                    width: question.width,
                    height: question.height,
                    content: question.content || '',
                    index: question.index,
                    question_id: question.question_id,
                    material: question.subjects && question.subjects.length ? question.subjects[0].parent_material : '',
                    materialId: question.subjects && question.subjects.length ? question.subjects[0].parent_material_id : '',
                }),
            )).mapKeys(Number.parseInt));
            state = state.set('answers', fromJS(_.mapValues(
                _.mapKeys(
                    action.payload,
                    answer => answer.id,
                ),
                answer => ({
                    id: answer.id,
                    page: answer.answer_page,
                    top: answer.answer_top,
                    right: answer.answer_right,
                    width: answer.answer_width,
                    height: answer.answer_height,
                    content: answer.answer_content || '',
                    index: answer.index,
                    question_id: answer.question_id,
                    material: answer.subjects && answer.subjects.length ? answer.subjects[0].parent_material : '',
                    materialId: answer.subjects && answer.subjects.length ? answer.subjects[0].parent_material_id : '',
                    scores: fromJS(answer.scores).toMap().mapKeys((__, score) => score.get('id')),
                }),
            )).mapKeys(Number.parseInt));
            break;

        case actions.SET_LAYOUT_OPTIONS:
            state = state.mergeDeep(action.payload);
            if (action.payload.type === 1)
                state = state.mergeIn(['settings'], {
                    marginTop: 1.5,
                    marginBottom: 1.5,
                    marginLeft: 1.5,
                    marginRight: 1.5,
                    marginMiddle: 1,
                    padding: 0,
                    questionSpace: .1,
                    width: 21,
                    height: 29.7,
                });
            else if (action.payload.type === 2)
                state = state.mergeIn(['settings'], {
                    marginTop: 4,
                    marginBottom: 1,
                    marginLeft: 1,
                    marginRight: 1,
                    marginMiddle: 1,
                    padding: .5,
                    questionSpace: .5,
                    width: 21,
                    height: 29.7,
                });
            if (state.getIn(['settings', 'template']) !== undefined) {
                switch (state.getIn(['settings', 'template'])) {
                case 0:
                    state = state.mergeIn(['settings'], {
                        marginTop: 1.5,
                        marginBottom: 1.5,
                        marginLeft: 1.5,
                        marginRight: 1.5,
                        marginMiddle: 1,
                        padding: 0,
                        questionSpace: .1,
                        width: 21,
                        height: 29.7,
                    });
                    state = state.updateIn(
                        ['questions'],
                        items => items.filter(item => !(item.get('page') < 0 && item.get('page') === actions.ITEM_TYPE_STYLE)),
                    );
                    state = state.updateIn(
                        ['answers'],
                        items => items.filter(item => !(item.get('page') < 0 && item.get('page') === actions.ITEM_TYPE_STYLE)),
                    );
                    break;
                case 1:
                    state = state.mergeIn(['settings'], {
                        marginTop: 2.7,
                        marginBottom: 2,
                        marginLeft: 1.4,
                        marginRight: 1.4,
                        marginMiddle: 1,
                        padding: .1,
                        questionSpace: .1,
                        width: 21,
                        height: 29.7,
                    });

                    let questionStyleItem;
                    let answerStyleItem;
                    state = state.updateIn(
                        ['questions'],
                        items => items.filter(item => {
                            if (item.get('page') < 0 && item.get('page') === actions.ITEM_TYPE_STYLE) {
                                if (questionStyleItem)
                                    return false;
                                questionStyleItem = item;
                                return true;
                            }
                            return true;
                        }),
                    );
                    state = state.updateIn(
                        ['answers'],
                        items => items.filter(item => {
                            if (item.get('page') < 0 && item.get('page') === actions.ITEM_TYPE_STYLE) {
                                if (item.get('id') !== questionStyleItem.get('id'))
                                    return false;
                                answerStyleItem = item;
                                return true;
                            }
                            return true;
                        }),
                    );
                    if (!questionStyleItem) {
                        const id = window.uuidv4();
                        questionStyleItem = fromJS({id});
                        answerStyleItem = fromJS({id});
                        state = state.setIn(['questions', questionStyleItem.get('id')], questionStyleItem);
                        state = state.setIn(['answers', answerStyleItem.get('id')], answerStyleItem);
                    }
                    const template = `<div style='position: relative; width: 100%; height: 100%;'>
    <div style='position: absolute; left: .9cm; top: .5cm; white-space: pre-wrap; text-align: center; text-align-last: center; font-size: 10pt;'>پایه <span style='background-color: #eaeaea; border-radius: 4mm; border: .2mm solid #9a9a9a; padding-left: 3mm; padding-right: 3mm;'>{{grade}}</span>
{{date:DD MMMM}} ماه
سال {{date:YYYY}}</div>
    <div style='position: absolute; right: 50%; top: .7cm; transform: translateX(50%); font-size: 11pt; font-weight: 700;'>مؤسسه آموزشی علامه حلی</div>
    <img style='position: absolute; right: 3.4cm; top: 1.3cm; width: 13.8cm;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABkUAAAAOCAIAAAAexYySAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVVJREFUeNrs2UFugkAYBlDbCAmQOkbRS9SrtUkPaQ/TYisLYUEXpe0VsDLwXkzcTfw/Zoh83D09vywAAAAAZiD/NZ95N9vt9IZq23bZfz0eDiGE8f/cuq67rnP2RrJ12qaRwxj0h6I/GnIAAPBAe1VJkjysVvOZtyiKLMvmM+9+V9rkROTtvfrps0IIUexdBwwAxu9yaS7eecC/SNNkHcNraQAY3FIEAMCAiiLvP3IAAOB67kUAAAAAQET0WQAAAADERJ8FAAAAQEz0WQAAAADERJ8FAAAAQEz0WQAAAADERJ8FAAAAQEz0WQAAAADEZCkCAIhX1319ns9yuKG6rruuk8NNtL2mmdhQm+3WlR2DoiiyLJPDCO13pRCAxV+f9Xo8Dr5uWbrLTI1/V4zWx+kkBA/zANNQVZUQgLiEEJIkiXqELM/jqrCj69zTNFmHMOya3wIMAGjSQmkF2wE0AAAAAElFTkSuQmCC
'/>
    <div style='position: absolute; right: 50%; top: 1.5cm; transform: translateX(50%); font-size: 9pt; font-weight: 600;'>آزمون {{title}}</div>
    <div style='position: absolute; right: 1.5cm; top: .5cm; width: 1.85cm;'>{{logo:imgw140}}</div>
    <div style='position: absolute; right: 50%; top: 50%; transform: translate(50%, -50%); opacity: .1;'>{{logo:imgw500}}</div>
    <div style='position: absolute; right: 0; bottom: 0; width: 100%; height: 1.4cm; background-color: #eaeaea;'></div>
    <img style='position: absolute; right: 0cm; bottom: 1.3cm; width: 21cm;' src='data:image/png;base64,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
'/>
    <div style='position: absolute; right: 50%; bottom: .4cm; transform: translateX(50%) rotate(45deg); width: .6cm; height: .6cm; text-align: center; border-radius: 1mm; background-color: #dadada; border: .2mm solid #9a9a9a;'>
        <div style='width: .6cm; height: .6cm; vertical-align: middle; display: table-cell; transform: rotate(-45deg);'>
            {{page}}
        </div>
    </div>
    <div style='position: absolute; left: .7cm; bottom: 2.4cm; background-color: #eaeaea; border-radius: 4mm; border: .2mm solid #9a9a9a; padding-left: 3mm; padding-right: 3mm; transform: rotate(-90deg); transform-origin: 0 0;'>www.mhelli.ir</div>
    <img style='position: absolute; left: .4cm; bottom: 1.5cm; width: 1.14cm;' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABjCAYAAAAB4ffpAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAB3RJTUUH4QoZAgoXDNXbEAAAIUNJREFUeNrtfXl4lNXZ9++ZfcnMZJtkkpCVJCTDkiCBEEF2SZFPoii0aAGr1bZ+kVcvxPLyFalgqy2vWpGiLFZAKCCgqOybaNhREgJk35OZSWbL7NuzfX/MxAZISCATgn37u65c4vM8c55zfs997nPf97nPOQT+g96AADAEQB6AXABhACoAfAGgFAAz0BXsFUpKSgCAC4AHgB/4LxcAIZVK73V15AD+L4CLABwAygCcBWAIXBvT1Y+Ie09b1+DxeKAoKhRAHID0uLi4DIlEksjj8SQEQbgoitLo9fpai8VSBaAFQBsAtp+rFQVgBYBn4Sf1zwC+AuAG8ACAdwAUB+67bmjPQBNqMBigVCqTKIqanJ2dnZOVlTU+PT09ZvTo0Y5BgwZBIpFwGIZh29vbqdLSUvHly5ep0tLS82fPnj1PkuRRAGWBjxLsqvEB/BbAbwKkvQ5gI4COF2nhl9YXAYwAcH6guQTgl1AAYQKB4LmxY8fuf//996uLi4stPp/PyrIsw3YPV21tbfsnn3zSMmPGjCNyufxXAORhYWHBrmIKgEoAegB/ANCVDpoHwApgDQZaSPl8PsLDwwFgREZGxubVq1dXaTQaO8uyJHtnoIxGo2fr1q3l48aNew+ASiAQBKuaBIAlAI4AmACgu4KnA9DBr5aeA6AYMGKnTp0KAGMefvjhL0+dOtXGsqz3Dgm9GeTx48dr4+PjPwbwKwCLAPwRwEoArwCYDSANdyZRagB7AIzt4blcADXw63o9gM8BvAW/BXHvMHjwYPD5fPXChQs/q6qqsvWRUJaiKE9xcbF+3rx5WoFA4BGLxW1hYWGWIUOGMGq1mk1JSXFERkY2AbgG4GPcXvo6IIB/kFoCgNPDs5EADgWI7fgjARR0ZxXwAKQDGAxABMAGoB5AHf6lvO8IERERMJlMkb/4xS9WrVixYmZERARfo9EQHo+HI5VK6aioKDYqKiqEIAhZL4pjdTqdY+3atdb169eHRkZG+goKCticnByn1+s1z5w5M00kEkk8Hk97ZWWlff/+/Yr9+/czpaWlbpZltwBYB0DTTdn5AF4IEFvXi7o8BKAQwCAAPgBFAD7s6kEF/CZGMfwjnwF+PXIZwAcAsnF3ZpqAIIgVQ4cONT3yyCOWkSNHalNSUjTx8fG6pKQk3fDhw9tmzZpl3bZtW4vNZrOxLEt3I6hMXV2dcfr06XqZTOZ88cUXNeXl5cYOldLe3t5ot9s1N6uLhoYG49KlS3WhoaEW+Lt5ZlffH8BOAL+7w7Yp4B/s4tCNyuHAPwLqAGyHXyHPC3wBE/yiXgZgxh2SGwrg9wBM0dHR1vHjxzsWL16s2bRpU9XGjRurXn31Vc3UqVOdSUlJFqlUanvooYf0Bw8e1LndbtfNrGq12vaJEycaVCqV45///KeGJMkbniFJ0lNRUVHq8/lu+S1FUd69e/c2xcXF2QEcIggioVMduQBehd+birwLwbkt4gGcgd9ek3S6zgcwH0B5gNwf4Jfc3iAHwD8VCkXbc88913bu3Dmtz+ezd0hf4I+ladpVX1+vXbt2rWHSpEmtoaGh9sLCQo3ZbO54lvX5fM5FixZpwsPD7bt379ayLOvrSqJramoaS0pKmrob7Pbu3dsUFRVlhd/A79C5efB7UgXBJhUAHoRf0T/fxT0O/Ibw8wHitwJI7KG8yQAup6enW/ft29fi8/mcvRnlzWaz9b333tPFxMRYn3/+eZ3dbneyLEvv379fp1AonG+88Uaz1+tt93q9nq4KMBqNlqNHj152OByuru7TNO1buXJlK5fLbQQwFf6uvAv+AS6kP4gtgF8NvNzDc5LAMx/CL+VdIQnA6ezsbGtpaanmNjqzK7gZhjGuXbu2USaT2f7whz+0tLe3t+fn5+u4XC6zffv2lvr6+sslJSWXSkpKblEHLMuSH3/8cVNpaampuxeYzWbLyJEjrfCrvD/C7/9nBYtI7k3//wSAWfB7HIdv8zsS/qjOEAAzAVwBYO90nwCwKDEx8f98/PHHzpycnBj0bLoAAFlaWtp25coVjUQisQmFQsfRo0dDT506FaLVaq2HDh2KSk1NtcybN4/JzMyMlMvloWVlZe6ampq2pKQkGZfL5QfK4VgsFpvJZGpLTU2NIgjilvFALBbz3W5325EjR7Lh73krAXwbLGI7wIO/25bBr0P39PJ3IQCWA9iEG9XCUD6fX7x69Wod23uPyvftt9/WHz16tNZqtdp8Pp/b4/G4z58/r09PT7cAoIVCoXvTpk2GztLPMAy1d+/exoMHD9Z2vm4wGFp+//vf17pcrm6tizNnzjjEYrEP/jhAUF1SDvxmwp8BbEDXJsjt4IDfT26B3+NQB64/kpqaGv/MM8+IelvhkpISU0tLi3fKlCmD5HK5jM/ni4RCoSg3Nzd00aJFXoIgmISEBOfkyZN96CT9BEFwZ86cGVFZWenVaDTGjusymSyytbU10u12W7t5JaFSqdhBgwaZ4LfNgxpT5QTIeBFAaqBwHYCv76AMK4B3ATQHSJ4HYPojjzxiDw8P742xD5ZlXceOHXONHj06msvl3uwZ8WfMmMEkJyfbZTIZR6lU3tKthUKhdPz48fK9e/dS8KspcLlc4eDBg/U2m83c3XvlcjmlVCp98A9evVFVd0TsBQBLAXwEv+T+EsCOOyzHBuCvAKoBfEQQxITx48dzOZze1VWj0bjDwsLaVCqVsKv7SUlJ0oSEBDFFUSzDMF3GYAcPHhxOEIRWq9XaA8SySUlJ7iNHjnDg94huAZfLZYVCIQvAiSDHdnnwe1Zrg1CWCf4Pk0AQxCMKhSICvZSClpYWPgCRVCq9uXEsAJbD4ciio6M9DQ0NtMFgYBUKBRiGYb744otWh8PBzJs3LzosLIzH5/NjfvjhB35sbCxLEARiYmKkhYWFYUKhsGnixIm0VCoVSiSSaJFIJOTxeByKojhOp5MA0ASADjaxwUQzgE8B/IzD4QjRS+/M7XZzAYg4nUScZVnm0qVLtrq6OvfMmTPDIiMjXa2trcKSkhJeamoqKioqDEuWLOHo9Xq+SqVqz8/Pj4qJiQmx2+0a+McNwZgxY8KWL1/eJhKJvDU1NVRbWxvV3NxsHjduXHtmZmZ4aWmpqKGhQQB/HCSo6I/gbDMAL03TNPzB4R7JlUqllFgs9qJTdzQajbYlS5Z4z5w5I//HP/5hpChK4fF4pGfOnDE8+eSTHo/Hw3g8Hr7T6Qy/evWqLz8/H2q12lVRUWEiSTKZz+dDLpeHPf3006GBDwWWZcEwDON2u3l1dXWO9957z6fX6/kAnARBgGWDpw2CqrADcLAsazCbze3o5UirUqlIgiAcLpfrx5axLMtSFMWhaVq6bds24tKlSxQAYt++fYKqqipPVlZWRE5ODheAOzQ01AcAUVFR3GvXrsHhcHQungBAEARBcDgcgsfjcWUyWXRSUpKqpqYmUiqVKsLDw19iWTYtmCT0B7F6lmUrTp06xdI03SsRiImJ4Wu12gij0fhjD4qKilKMGjVKCIA5ceIEceXKFSpEHmLXaDXiVatWOYqLi808Hs8oFArdjY2NzsOHDzu++uorz6FDhyIDqqVbMAzjWb9+vbm1tZV59913PZ988sm07OzstwEMDxYJ3L4XcQucAOKNRuOU2bNnO0NDQ3ucr+ZyuYLy8nIyOjqaViqVIrfbzTQ0NJi++OILS21trYCmaYZlWWlMTIyBz+dT58+dDy8qKqp7/PHHJbNnz47m8XhMXV2doaqqql2tVvOnTJkSLhAIuhMa744dOwzLli0LmzRpku2Pf/yjYvjw4WEqlSr07NmzMTab7WygDfclhgIo/c1vfqP3er0uthcoKyvTLl68uGTNmjXXX3rppeuvv/562bFjx5q++uorg1Qq1aelpRmuX79uv379umXChAkGAK7CwsJmo9FoZVmWpGmadLlc7kBgpsvJSLfb7dy0aVOjQqFwpqWlGSoqKqydAjPUypUrG3g83mvoH4ELCsQAvpTJZK7t27c398at9fl89OrVq/Vr167V1tXVGSmKYjwej6WwsFArEAhs69ev/zGQU15e3j5lypQ2giCc48aNMx48eFAXmN3tEhRF2U+fPq2bP39+q0gksg8fPrytqKjIfPMH0Gq1rtGjR38LYNhAE9gVYqRS6evZ2dmXoqOj2+Lj4y3ffPNNUy9jBlTHP1wul2Xp0qU6LpfrevbZZ3VOp9PNsixNUZSPZVlGp9M5ly1b1hQREWFVKBTtEydOtK9cubL5yJEjVdeuXWuorq7WfP/997Xvv/9+/c9+9jNLRESEWSaTOZ599tnmmpoaW1dSzTAM/c4779QTBPHKQJN4M7Li4uK2rlmzptlkMrlPnjxpTkxM1EdHR1vXrVvXYrVarb0gl6yrqzM988wzGg6H4y4oKNBrNBrLiRMn7Bs2bLAuWbKk8dChQ0aWZRmKosji4mLj7373u9bMzMz2kJAQnUAgMItEIq9EIiGFQqFdKBS2JSQkGOfPn2/4+uuv60tKSnQul8vT3cu///57T0RExN/hn/W4LzAqNjb2iz179uhpmu6IKDFnzpwxZWVlaYRCoTM/P1+/e/fuFoPBoHO73T6v18v4fD7G5/MxbrfbXVtb2/zXv/61dfjw4SaBQGBbuHChtrW11VFcXGyIi4szRUdH2wcPHtyuVCoN33zzjb6zsDU2NhoPHjyo/eSTT6xr166l16xZw6xfv969Z88e/fXr11uvXbtmmj9/vmbatGlX6+rq2rojVqPR2CZNmrQX/inzAUdibGzsnt27d+u76mJNTU22ZcuWNScmJlrkcrk+Li7OkZmZST/00EO2/Px846RJkyyZmZm+qKio9tDQUFNOTo5hx44dGqfT6WVZll23bp0DgHvWrFmuxYsXmwB4Fy5caCFJslvJu4ks69SpUxuSkpLaCwsL6xwOR7czGU6n0/XCCy9cBDCyL4QEw/PiiMXiZxYvXpz7xBNPRKALTys+Pl725ptvSp9//nnL4cOHvdeuXZPU1NRYWltb3QaDgZFKpdz09HQMGTIE48aNc06aNEkpl8t/dIlpmuYCIIRCIZOXl+fk8XhcgiAotpeekt1u97744ouinJwc7NixA8ePH7cWFBRIunpWKBRyQ0ND5UHipk9Izc3NPdrW1ubujfR0DFI2m83W0tJibGhoMGi1WpPL5XKw3ZhJlZWVtmeffbZy+/btLVar1bVnzx5zZWVlr8y4LqTX/tJLL/3Q3Nxs6eq+x+NxL1q06DL6KLF9BkEQv3zrrbeuBoz4/gLj8/m8NE13WBZ3Mn92A6xWq2vOnDlnjxw5Yujqfmtrq33mzJlfwJ+wctfos7jzeLzBDzzwQDqHw+nPXFuCz+d3DoDftStus9mIsrIyaRfTYACA1tZW/uXLl3Xwh0Hvnpc+NljA5XKlcrmc35uHr1y50ub1eqWxsbGc8PBwQiKRiHAPk58ZhqE2b95skMvlYWq1uivvivnhhx8sbW1tLegjsX0NwhAsy/IYhukVOVqtll2xYoUvLy+v9eWXX25qampq7ycObwFJkr7Nmzfrt2zZQrzyyivCuLi4WxJqHQ4Hu3PnzgaGYYr6+r6+SqyXpmmrRqOxwp+rf1uCZ8yYEVVTU+OMj49PnDt3rq+LGYNggqZpmvF4PERjY6Nz3bp15jNnzhArVqyQBKyXW/Dtt98ai4uLy+HP9OkT+qxjKYq6euLEicrHHnssh8/n9yS5hFgs5qakpNimTZsmR5CDHQ6Hw1lXV0dqtVpxY2Oju6yszFheXm73eDzKESNGcD/99NOQYcOGhaELATCbze6NGzcajUbjFqFQ6PJ6vQNLLIDz586dsxoMBm9sbKy4J2KHDRvmXb58ufaJJ57gpqWlyYNBqN1ud+/du9d64MABtrq6WiuVSsXJyckRGRkZcTk5OfYxY8YQaWlpEZxuZjcZhqG3bNmiP3z48GcAzveV1GCBEIvFS9euXdvA3n7tAMuyLOvz+cgVK1Y05efn1549e9bkdru78p5Ip9PptNvtDoqibutdNTY2Wn75y182jxo1qu7DDz/UlZeXO/V6vdXtdjt7aZYxR48eNSUmJv4TQEKf2eggJUjlZObl5X2ybds2dUpKSo+5BC6Xy7d69WrDzp07PaNGjRJOnTo1VKVSOQUCAWM2m0Xl5eXElStX2h0OBz1kyBDZzJkzBRMnTpSIRKIbpsebmposL730kkUmk+Gtt96KjI+Pl+DOBmT23Llz1hdffPFiSUnJUvhzgoOCYOk4S0tLi5jD4QybPHlyCI/Hu225fD6fO378eMno0aN5LS0t1Pbt21u//PJL59GjRx1Xrlwxy2Qy7pQpU+IyMjJCrl+/btm2bZurqanJMXLkSJFUKuUBIIxGo+O1116zhIaGMu+88060SqXq1cRlJzDfffed7eWXXy4tLi7+M/xJcfcllHK5/MNNmzbpaJqmetEFWZZlWYqifGaz2aPVakmtVku2t7d7SJL0BtQK7fF4PDU1NY6lS5fWPvbYY1VFRUUGq9XqeOWVV5rmz59f3d7efseurdvt9m3btk2blpb2NYCJA01cb5CSmJi467PPPjN0cj+DApIkqY0bNzbl5eXVFRQUaOfMmVOt1Wp7k297A4xGo2fZsmVlSqXyPQBDQkL6JR22XzA0Pj5+90cffaRzuVx9XWp0A2iapg4ePNj661//uqa+vt5xhz9nqqqqbD//+c+vwL/icODWZPUBQ2Qy2YbCwsKqysrKnlYa3ikYiqJ6rWo6fnP27FnDpEmTzsKfAzzgIcG+IBLAc2PGjDn5wQcfNLa2tnoYhrnrqFRfPsSpU6faHnjgge8AzOD0NlPvPgcBYLBIJHp91KhRp/7yl7/UX7p0yW0ymexBluJuST1y5EirWq0+BWDSQJPRH+DCn2vwX0qlcmNBQcH3b7/9tvHixYttXq/3Trt1r0k9ffq0fvjw4acATPvwww/71oKfACIBjALwbGpq6mdPPfVU8aFDh3Qmk8kXTCm+evWqOS8v7xKAGUKh8L7Zl+FegIB/DcM4uVz+P9OmTftu69atRr1eb+8rqVqt1vXoo49eA/AU7qPNLu4pAvsWCAA8xOfzP5o+fXrNmTNnLOxdTr94vV5y8eLF1QCWwb8O+D+A37ZcmJ6efmrfvn1tFEXdsZPx+eeft4aFhW0BoBzoxtxXePLJJwEgOyUlZfOWLVsaSJLsNbkajcY2bdq0MwByAj3hP+gCcYMGDfpg48aNjb2UXHr9+vWtXC53Efon7/ffCvExMTG7duzY0cowzG3NMr1e75kyZcoR+HcX+g96gVEZGRknLly4YLkdsZcuXfIqFIrN6KdFxv+umJufn19iNBq7CxEyn376aZ1QKPzv7vIF7jV+Krro2IkTJ6refvvtdpvN5rr5JsMwRH19vc7r9ZYMdEU7cN+mhHcGQRAehmEMVVVVc5ubmx3R0dEugUAgCqSAsmazmfrb3/5mrq+vPwigYaDrC/wEwmcCgQA+ny8SQOqsWbPY3/72t6ElJSXuoqIii0gkosLCwrhOp5MXExOTFBcXl6PRaL7FfbCJ431LrFwuh81m4wkEggdnzZr1RFhYWC4AV1tbm2zGjBlKuVxOOBwOiMViSCQSTJ8+nfrVr371pEajKU1LSztSXV09oPW/L4n9/PPPMXv2bHV6evrTixYtmvbEE0+oIyMjGbPZDJ1OZ1i2bJm0trY2JDExkcnMzBSkpKTwnE4nLzc39wGj0bjq6tWrjmHDhp25du3aQDfl/oBEIgEAkVAonDt37tyikydPGmiavmFDHZIkPa+++qp21apVmj179rSvXLmS1ul0LEmSLEVRbFFRUfuwYcMOA8j9N4lp3z24XC4UCgUAhKalpf3322+/XaPVat3sTWHEwG4apo0bN2o9Ho+LZVlqz549jr///e+00/mvecX9+/e3JiQk7AWg5nA4+F9JcKdGx+Xn5//Pl19+aSJJsisvizl16lTLpk2b6juveqEoyrNu3TrL559/fkM0bN++fW3JyclbASQPdBsHBElJSQCQOmfOnHWXLl3qMsuaZVm2vr6+efXq1WUGg+GWKW+r1epes2aNu6qq6uZIly4pKelvAGK53J+EZRkcREZGAkDqggULNldXV+u6I9Vms9n/9Kc/VQa22mNZ1p90YTAY7B0p+tevX3d99NFHpMNx46z4vn37NGq1+k0AYf8rIl4BCRr89NNPr29qatKw3YPcu3dvzYEDB2rYf61cpNavX6998MEH63Q6XceiEmrfvn3Ow4cP36yX2QMHDmiysrL+C4E4QnR09EA3P/jg8/kIZJ9EFxQU/KWqqqrudsGV2tpa87vvvltpt9s7xwl8q1atMkZFRblLS0vbOy4ajUb3m2++6a6vr2dvJvfrr7+uyMzM/AUC3qZS+e8ZB5fk5eUtuXjxYvXtSKUoyrtly5brFRUVt0i02Wz2XLhwoc3lcnU2x5hjx47Z3n///U6LI/2gaZrevXv3D+np6dPZIO6kcV8hIiJi7q5du6506tpdory8XLNjx47KO8l8sdlsnlWrVrkrKipuued2u70ffPDBEblcPmzEiBH4t5kSl8vlADBi+fLlXwUSg28nra6tW7eWNTU1mXtLaofUHj582L5p06Yup9J1Op2rsLBwLYCwQYMG4dFHH+2Xtt5TG8Tr9Uoefvjhl1577bUClUp126S00tJSm91ud40dOzaaIIg7qSehUCjYkpISX2xsLD/wMX9ESEgIPyIiQu3xeCynT5++pFKpmMbGxqC39Z65JAsWLIBEIhldUFCQn5GRcdu1BzRNU7W1tbqEhIQIgiDueKt4pVLJFQqF3IaGhi7vZ2dnh4wdO7ZwwoQJ6n7Y5v+eQ5ybm7tBq9X22LV1Op39jTfeqCNJ8q43SK+srLRv2LDB6/V2nUlaXl7OzpkzZy36qdfeSyd69Jw5czKUSmWPeanV1dWarKwsisfj3W49Q8cu7l0iMTGRr9FoODdtFfUjkpOTMWLEiMmRkZHDIiMjEcQzFADcO2K5cXFx48eOHZvF4/FuOynF+s81kI8ePbrbPmqxWLzLly9v2Lx5cxNFUV1unScQCIRZWVnOysrKLskXCoUYN27ckJCQkPwFCxbA5/Php4jkZ5555vP29vYe87J0Op12w4YNl51OZ7e5BKWlpR6BQGB/4IEHqmw2W3fLlZjS0lLjunXruk1VampqYhcsWHAMQFx4eDiCORHZ787z4MGDUVtbm56enp4XGhraYy7VhQsXBMnJyQqJRNJtKxMSErgrVqwwpKSkSCQSSXcLpAmJRCK32+0UwzCCrkKHgwYNwtChQ3M4HE5KWFiYxmzudkfU+xL89PT0N06fPn27eEAH3Dt37iy7cuVKj5vy0DTt6ymJw2QyeTZt2qRta+t2Cxj2+PHj5Lhx4/4fAG4gJhwU3AsdG6JUKicNHz68R2ltb2+n5HK5LTU1tUefk8Ph8Huyb6VSKS0UCk0mk6nbNZyjRo3iJScnTwcgDuYKmn4lNjDSpg0ZMiRSKpX2aDCaTCbCZDLFSSSSXu2U3BP4fD4hFAq5bre722cUCgWGDx8eLRaLk4OpY/uVWB6PB5FIlDV58mSSy+X2WGsul2tWqVRssOpFEASEQqGIw+EIbvfMtGnTYqKjox8UCoV3Uvxt0a/EcrlcCASCjLS0tEj0sFUzy7KMy+UyqNXqvu48zAZW5zA+n48hSZIrEAiIsrIynDp1Cl3ZtdHR0dKoqKik2traoDkL/Uqs3W4XhISERIeGhsagh5R1kiRRXFwsDAsL62lpfndgtFqts7S0tKGqqqq4rq6u+NKlSzVffvml8OjRo+ByuXA6nbhw4QIY5sZ8jpCQEGbEiBFRAGJ/EsQCkKjVao9MJutRDZAkSR48eDCyurra4vF4DIFRv1e7ELMsy5w/f167c+fORo1Gw1MqldERERFRIpEoTK1WSxwOB3Xu3DloNBoIBIJbZm2lUimbkZERH0xi+9uOJYYOHeoWi8V0T+/i8/neCRMmtBcXF1vPnj1LVVZW8mQymTkzM9OoVquJ8PDwQWKxWCKVShmRSMQJWAQciqJ833zzjb6pqcn81FNPJatUqhAEekdOTg5ycnIYi8WCyspKFBUV4fjx41AqlUhPT/+RYB6Px1WpVInwnzf7kyCWio2N9fJ4vB7FTiAQyF544YXBFEURJEkSHo+HIUnSazKZuJWVldxDhw55FQqFIT093SCVSgU2my3W5/PJfD5fs0Ag4D799NODRSJRV5sAc0JDQ5Gbm4uRI0eiqqoKX3/9NSZMmIAxY8Z0eFtcoVAYDUAYrL26+5tYr81mIymK6o3KITgcDl8gEEAgEEAqlXIBqFQqlWro0KEAAJZlpXa7XabValmTySR2Op2c7OzsqCFDhsjQ85F9EAgEGDZsGFQqFXbv3o2UlJQf575omuYgiJGufiV27ty5vgsXLjBOp5MIRtyTIAipXC6XyuVyZGRkdFyW3Gk5DMOAIIjOupb2eDwuANxgSCvQz8QeO3YMAoHAYLPZtPCfKTgQYPR6vZEkSVosFkfqdDr+/v37MX78eERE+HeJYlmWbm1t1cN/QnJQ0K/E0jQNi8Vy7uTJkxq1Wh2HgVklyDocDrNerxfU19dzjh07hoULFyI3N/fHB6xWK1tUVFSH7g+ovL8QyDwRjx8/fl1lZaWBHThQLMvSp0+fZt99913W57vxRMDLly+3RURErEPXpyXfFfp1MpFhGOTn51OnT59ucDgcqWq1OkKhUEg66bauJJgF/Cdt0DRNkCQJkiTh8/lsZrNZV11drT9//rz13LlzDoPBYIqIiGCEQqGkKz/fZDK1fffdd66Ghgbp6dOnObW1tXj00Ud/HLBYloXD4cCaNWtKT548+aFYLK4I1hni96xrcrnc1Ly8vIUzZszIGTNmTEhYWFgEj8eTEQQhCJwQR7Is6/b5fHaHw+E0Go3elpYWqqqqilNXVwe3293EsmyFy+XSGo1Gi81mg0KhiBg5cmTOwoULR2VnZ49ISEgQdJ58pCiqfcOGDW0bNmxIf/zxxzlTp05llUolQZIk3G43GhoaqKKiooYDBw68VVdXtxV3eebugBI7YcIEfPfdd1wAsWKxeAiHw4kmCEIaMPTZQKO8LMs6GYZx0jTtIEnSzDCMAf5jrZjAH8sGhu7AB+GLxeJR48aNK5g6deqUjIyM5KysLK9MJkN9fT1n8+bNrbt27fo+OTnZFBIS4vR6vVyPxyO12WxEaGhoq0QiOV5UVHRVJpMxXq83aFM098eiqOBABiArISEhJTs7O0koFIY1NjaaLl68eB7AmdTUVLdCoQBFUfB6vbDZbIiMjERsbCxmz56NEydOYNeuXUGrzP8HWhEirIX8FcYAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTctMTAtMjRUMjI6MTA6MjMrMDQ6MDDG2aIYAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE3LTEwLTI0VDIyOjEwOjIzKzA0OjAwt4QapAAAAABJRU5ErkJggg=='/>
</div>`;
                    state = state.mergeIn(
                        ['questions', questionStyleItem.get('id')],
                        {
                            page: actions.ITEM_TYPE_STYLE,
                            top: -state.getIn(['settings', 'marginTop']),
                            right: -state.getIn(['settings', 'marginRight']),
                            width: state.getIn(['settings', 'width']),
                            height: state.getIn(['settings', 'height']),
                            content: template,
                        },
                    );
                    state = state.mergeIn(
                        ['answers', questionStyleItem.get('id')],
                        {
                            page: actions.ITEM_TYPE_STYLE,
                            top: -state.getIn(['settings', 'marginTop']),
                            right: -state.getIn(['settings', 'marginRight']),
                            width: state.getIn(['settings', 'width']),
                            height: state.getIn(['settings', 'height']),
                            content: template,
                        },
                    );
                    break;
                }
            }
            if (isPaperScanTemplate(
                state.get('type'),
                state.getIn(['settings', 'template']),
            )) {
                state = state.mergeIn(['settings'], PAPER_SCAN_TEMPLATE_SETTINGS);
                ['questions', 'answers'].forEach(collection => {
                    state = state.updateIn(
                        [collection],
                        items => items.map(item => item.get('page') === actions.ITEM_TYPE_STYLE
                            ? item.merge({
                                top: -state.getIn(['settings', 'marginTop']),
                                right: -state.getIn(['settings', 'marginRight']),
                                width: state.getIn(['settings', 'width']),
                                height: state.getIn(['settings', 'height']),
                            })
                            : item),
                    );
                });
            }
            break;

        case actions.REORDER_LAYOUT:
            const order = _.mapKeys(
                _.mapValues(action.payload, (id, index) => ({index: Number(index), id})),
                item => item.id,
            );
            state = state.updateIn(
                ['questions'],
                items => items.map(item => item.get('question_id') ? item.set('index', order[item.get('id')].index) : item),
            );
            state = state.updateIn(
                ['answers'],
                items => items.map(item => item.get('question_id') ? item.set('index', order[item.get('id')].index) : item),
            );
            break;

        case actions.UPDATE_QUESTION_LAYOUT:
        case actions.UPDATE_ANSWER_LAYOUT:
            let items;
            let view;
            if (action.type === actions.UPDATE_QUESTION_LAYOUT) {
                items = state.get('questions');
                view = 0;
            }
            else {
                items = state.get('answers');
                view = 1;
            }
            action.payload.forEach(item => {
                let settings = state.get('settings');
                if (settings.getIn(['noStylePages', String(view), String(item.get('page'))]))
                    settings = settings.merge({
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        marginMiddle: 1,
                    });
                const split = settings.getIn(['split', String(view), String(item.get('page'))]) === true;
                let availableWidth = settings.get('width') - settings.get('marginRight') - settings.get('marginLeft');
                if (split) {
                    availableWidth = (availableWidth - settings.get('marginMiddle')) / 2;
                }
                const availableHeight = settings.get('height') - settings.get('marginTop') - settings.get('marginBottom');
                if (item.get('top') < 0)
                    item = item.set('top', 0);
                if (item.get('top') + item.get('height') > availableHeight)
                    item = item.set('height', availableHeight - item.get('top'));
                if (item.get('right') < 0)
                    item = item.set('right', 0);
                if (item.get('right') + item.get('width') > availableWidth)
                    item = item.set('width', availableWidth - item.get('right'));
                if (item.get('height') !== null && item.get('height') < .6)
                    item = item.set('height', .6);
                item = fromJS(item);
                if (item.has('scores') && item.get('scores'))
                    item = item.set('scores', item.get('scores').mapKeys((_, score) => score.get('id')));
                items = items.set(item.get('id'), item);
            });
            if (
                items.some(item => item.get('top') === null) &&
                items.every(item => item.get('height') !== null)
            ) {
                let page = 0;
                let bottom = 0;
                let column = 0;
                items = items.sortBy(item => item.get('index')).map(item => {
                    let settings = state.get('settings');
                    const availableHeight = settings.get('height') - settings.get('marginTop') - settings.get('marginBottom');
                    let split = settings.getIn(['split', String(view), String(page)]) === true;
                    if (!item.get('question_id'))
                        return item;
                    const height = item.get('decorativeHeight') || item.get('height');
                    if (bottom + height > availableHeight && (
                        item.get('page') === undefined ||
                        item.get('page') === null ||
                        column === 0 && split
                    )) {
                        if (split && column === 0) {
                            column++;
                        }
                        else {
                            page++;
                            column = 0;
                        }
                        bottom = 0;
                    }
                    else if (
                        item.get('page') !== undefined &&
                        item.get('page') !== null &&
                        item.get('page') > page
                    ) {
                        column = 0;
                        bottom = 0;
                    }
                    if (settings.getIn(['noStylePages', String(view), String(page)]))
                        settings = settings.merge({
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginMiddle: 1,
                        });
                    page = item.get('page') === null || item.get('page') === undefined ? page : item.get('page');
                    split = settings.getIn(['split', String(view), String(page)]) === true;
                    if (!split) {
                        column = 0;
                    }
                    let availableWidth = settings.get('width') - settings.get('marginRight') - settings.get('marginLeft');
                    if (split) {
                        availableWidth = (availableWidth - settings.get('marginMiddle')) / 2;
                    }
                    const top = item.get('top') === null || item.get('top') === undefined ? bottom : item.get('top');
                    bottom = top + height + state.getIn(['settings', 'questionSpace']) + .05;
                    const right = item.get('right') || (column === 0 ? 0 : availableWidth + settings.get('marginMiddle'));
                    const width = item.get('width') || availableWidth;
                    return item.merge({top, right, width, page});
                });
            }
            items = items.map(item => {
                let settings = state.get('settings');
                if (settings.getIn(['noStylePages', String(view), String(item.get('page'))]))
                    settings = settings.merge({
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        marginMiddle: 1,
                    });
                const availableWidth = settings.get('width') - settings.get('marginRight') - settings.get('marginLeft');
                const availableHeight = settings.get('height') - settings.get('marginTop') - settings.get('marginBottom');
                if (items.some(
                    item2 => (
                        item.get('page') === item2.get('page') &&
                        item.get('id') !== item2.get('id') &&
                        item.get('right') < item2.get('right') + item2.get('width') + state.getIn(['settings', 'questionSpace']) &&
                        item.get('right') + item.get('width') + state.getIn(['settings', 'questionSpace']) > item2.get('right') &&
                        item.get('top') < item2.get('top') + item2.get('height') + state.getIn(['settings', 'questionSpace']) &&
                        item.get('top') + item.get('height') + state.getIn(['settings', 'questionSpace']) > item2.get('top')
                    ) || (
                        item.get('top') < 0 ||
                        item.get('right') < 0 ||
                        item.get('top') + item.get('height') > availableHeight ||
                        item.get('right') + item.get('width') > availableWidth
                    )
                ))
                    item = item.set('overlap', true);
                else
                    item = item.set('overlap', false);

                
                return item;
            });

            state = state.set(action.type === actions.UPDATE_QUESTION_LAYOUT ? 'questions' : 'answers', items);
            break;

        case actions.UPDATE_SCORE:
            state = state.mergeIn(
                ['answers', action.payload.questionId, 'scores', action.payload.id],
                action.payload.score,
            );
            break;

        case actions.ADD_ELEMENT: {
            const id = window.uuidv4();
            const availableWidth = state.getIn(['settings', 'width']) - state.getIn(['settings', 'marginRight']) - state.getIn(['settings', 'marginLeft']);
            state = state.mergeIn(
                ['questions', id],
                {
                    id,
                    page: action.payload.view === 0 ? action.payload.page : actions.ITEM_TYPE_HIDDEN,
                    top: 0,
                    right: availableWidth / 4,
                    width: availableWidth / 2,
                    height: 5,
                    content: '',
                },
            );
            state = state.mergeIn(
                ['answers', id],
                {
                    id,
                    page: action.payload.view === 1 ? action.payload.page : actions.ITEM_TYPE_HIDDEN,
                    top: 0,
                    right: availableWidth / 4,
                    width: availableWidth / 2,
                    height: 5,
                    content: '',
                },
            );
            break;
        }

        case actions.ADD_QUESTION:
            state = state.mergeIn(
                ['questions', -action.payload.id],
                {
                    id: -action.payload.id,
                    question_id: action.payload.id,
                    page: null,
                    top: null,
                    right: null,
                    width: null,
                    height: null,
                    content: action.payload.content || '',
                    index: state.get('questions').count(),
                },
            );
            state = state.mergeIn(
                ['answers', -action.payload.id],
                {
                    id: -action.payload.id,
                    question_id: action.payload.id,
                    page: null,
                    top: null,
                    right: null,
                    width: null,
                    height: null,
                    content: action.payload.answer || '',
                    index: state.get('answers').count(),
                    scores: null,
                },
            );
            break;

        case actions.REMOVE_QUESTION:
            state = state.removeIn(
                ['questions', action.payload],
            );
            state = state.removeIn(
                ['answers', action.payload],
            );
            let index = 0;
            state = state.update('questions', questions => questions.sortBy(item => item.get('index')).map(
                item => {
                    if (item.get('question_id'))
                        return item.set('index', index++);
                    else
                        return item;
                },
            )).toMap();
            index = 0;
            state = state.update('answers', answers => answers.sortBy(item => item.get('index')).map(
                item => {
                    if (item.get('question_id'))
                        return item.set('index', index++);
                    else
                        return item;
                },
            )).toMap();
            break;
        }
    }
    return state;
}
